import { api, AuthResponse } from './api';
import { setMyChatwootAgentId } from './chat/my-availability';

export async function login(
  email: string,
  password: string,
  tenantSlug: string,
): Promise<AuthResponse & { requiresPasswordChange: boolean }> {
  const data = await api.request<AuthResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password, tenantSlug }),
    skipAuth: true,
  });

  api.setTokens(data.accessToken, data.refreshToken);
  api.setUser(data.user);

  const requiresPasswordChange = !!data.user.mustChangePassword;

  if (!requiresPasswordChange) {
    try {
      const perms = await api.request<{ permissions: string[]; denied?: string[]; isGkAdmin: boolean; activeModules?: string[]; voiceEnabled?: boolean; suporteAvailable?: boolean }>("/auth/permissions");
      const { savePermissions, saveModules, saveVoiceEnabled, saveSuporteAvailable } = await import("./permissions");
      savePermissions(perms.permissions, perms.isGkAdmin, perms.denied ?? []);
      saveModules(perms.activeModules ?? []);
      saveVoiceEnabled(perms.voiceEnabled ?? false);
      saveSuporteAvailable(perms.suporteAvailable ?? false);
    } catch {
      // silencioso
    }
  }

  return { ...data, requiresPasswordChange };
}

export async function logout(): Promise<void> {
  try {
    await api.request('/auth/logout', {
      method: 'POST',
      body: JSON.stringify({ refreshToken: api.getRefreshToken() }),
    });
  } finally {
    // #148: fecha o socket de presença ANTES de limpar tokens — reforço
    // client-side do teardown server-side (não depende do unmount do layout,
    // que pode correr com a reconexão automática do socket).
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("gk:presence:disconnect"));
    }
    api.clearTokens();
    // #102: zera o agentId em memoria pra nao vazar entre sessoes (logout +
    // login de outra conta na mesma aba sem reload).
    setMyChatwootAgentId(null);
  }
}
